import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateRandomLocalPart } from '../utils/generateEmail';
import { PageTitle } from '../components/PageTitle';
import {
  IconRefresh,
  IconCopy,
  IconCheck,
  IconMailbox
} from '@tabler/icons-react';
import '../styles/GeneratedPage.css';

export function GeneratedPage() {
  const [localPart, setLocalPart] = useState(generateRandomLocalPart());
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  const email = `${localPart}@ephemail.space`;

  const handleRegenerate = () => {
    setLocalPart(generateRandomLocalPart());
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      alert('Failed to copy.');
    }
  };

  const handleGoToInbox = () => {
    navigate(`/inbox/${email}`);
  };

  return (
    <>
      <PageTitle title="Your Temporary Email Address" />
      <div className="generated-container">
        <div className="generated-email-box">
          <IconMailbox size={20} className="mail-icon" />
          <div className="generated-email">{email}</div>
          <button className="inbox-button" onClick={handleGoToInbox}>Go ➡</button>
        </div>

        <div className="generated-actions">
          <button className="regenerate-btn" onClick={handleRegenerate}>
            <IconRefresh size={18} />
            Regenerate
          </button>

          <button className="copy-btn" onClick={handleCopy}>
            {copied ? <IconCheck size={18} /> : <IconCopy size={18} />}
            {copied ? 'Copied!' : 'Copy Email'}
          </button>
        </div>
      </div>
    </>
  );
}
